// Brunch automatically concatenates all files in your
// watched paths. Those paths can be configured at
// config.paths.watched in "brunch-config.js".
//
// However, those files will only be executed if
// explicitly imported. The only exception are files
// in vendor, which are never wrapped in imports and
// therefore are always executed.

// Import dependencies
//
// If you no longer want to use a dependency, remember
// to also remove its path from "config.paths.watched".
import "phoenix_html"

// Import local files
//
// Local files can be imported directly using relative
// paths "./socket" or full ones "web/static/js/socket".

import "./socket"

import Vue from 'vue/dist/vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VeeValidate from 'vee-validate';
import HighchartsVue from 'highcharts-vue';

// import Toast from "vue-toastification";
// import "vue-toastification/dist/index.css";

// Vue.use(Toast, {
//   transition: "Vue-Toastification__bounce",
//   maxToasts: 20,
//   newestOnTop: true
// });

import swal from 'sweetalert2';
import VueTelInput from 'vue-tel-input';

window.Swal = swal;

Vue.config.devtools = false;
Vue.config.debug = false;
Vue.config.silent = true;

Vue.mixin({
    data() {
        return {
            window: window
        }
    },
    methods: {
        showValidationErrors(errors, scope = null) {
            Object.entries(errors).forEach(([key, value]) => {
                this.errors.add({
                    field: key,
                    msg: value[0],
                    scope
                })
                this.$validator.flag(key, {
                    valid: false,
                    dirty: true
                })
            })
        }
    }
})
Vue.use(VeeValidate, {
    classes: true
});
Vue.use(VueAxios, axios);
Vue.axios.defaults.headers.post['x-csrf-token'] = window.csrf_token;

Vue.use(HighchartsVue);
Vue.use(VueTelInput);
require('./components');

if (process.env.NODE_ENV === 'production') {
    Vue.config.devtools = false;
    Vue.config.debug = false;
    Vue.config.silent = true;
}



